import classNames from 'classnames';
import React from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export const CLASS_NAME_FOR_HOVER_TARGET = 'hoverActionButton-target';
export const CLASS_NAME_FOR_HOVER_BUTTON = 'hoverActionButton-button';

interface HoverActionButtonProps {
  icon: BenchlingIconName;
  onClick: (event: ElementMouseEvent) => void;
  className?: string;
}

export default function HoverActionButton(props: HoverActionButtonProps): JSX.Element {
  return (
    <div
      className={classNames(CLASS_NAME_FOR_HOVER_BUTTON, 'invisible', props.className)}
      onClick={props.onClick}
    >
      <BenchlingIcon icon={props.icon} />
    </div>
  );
}
